import { Component, EventEmitter, Input, Output } from '@angular/core'
import { ImageComponent } from '@shared/components/common/image/image.component'
import { TranslatePipe } from '@ngx-translate/core'
import { UseLocales } from '@modules/lang-module/decorators/use-locales'
import ru from './core/locale/ru.json'
import en from './core/locale/en.json'
import { ButtonComponent } from '@shared/components/ui-kit/button/button.component'

@UseLocales({ ru, en })
@Component({
	selector: 'app-confirm-close-position',
	templateUrl: './confirm-close-position.component.html',
	styleUrl: './confirm-close-position.component.scss',
	imports: [ImageComponent, TranslatePipe, ButtonComponent],
})
export class ConfirmClosePositionComponent {
	@Input() isLoading: boolean = false
	@Output() onConfirm: EventEmitter<void> = new EventEmitter<void>()
	@Output() onCloseDialog: EventEmitter<void> = new EventEmitter<void>()

	protected confirm(): void {
		this.onConfirm.emit()
	}

	protected close(): void {
		this.onCloseDialog.emit()
	}
}
